import { render } from "./S139110.vue?vue&type=template&id=ae248af2"
const script = {}
script.render = render

export default script